import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Restores the public-page navigation contract without changing app-shell scroll. */
export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/app")) return;
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
